export class ZonaBarrio {
  id: number;
  idZona: string;
  zona: string;
  indicadorHabilitado: boolean;
  auditoriaUsuario: string;
  auditoriaFecha: string;
  descripcionDivisonPolitica: string;
  idBarrio: string;
  idZonaBarrio: string;
  camino: string;
  codigoDivisionPolitica: string;
  codigoPostalDivisionPolitica: string;
  gentilicio: string;
  idDivisionPolitica: string;
  idDivisionPoliticaAgrupacion: string;
  idDivisionPoliticaArea: string;
  idDivisionPoliticaPadre: string;
  idDivisionPoliticaTipo: string;
  idEstratoDivisionPolitica: string;
  indicativoDivisonPolitica: string;
  poligono: string;

  constructor(){
    this.indicadorHabilitado = true;
  }
}
